import { baseApi } from "@/shared/api";
import type {
  MsbContract,
  MsbCompletionAct,
  CreateMsbCompletionActDto,
  UpdateMsbCompletionActDto,
} from "../types/msb";

export const msbContractApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMsbContract: builder.query<MsbContract, void>({
      query: () => ({
        url: "/api/hr/self-service/msb-contract/",
        method: "GET",
        credentials: "include" as const,
      }),
      providesTags: [{ type: "MsbContract" as const, id: "CONTRACT" }],
    }),

    createMsbCompletionAct: builder.mutation<MsbCompletionAct, CreateMsbCompletionActDto>({
      query: (body) => {
        const formData = new FormData();
        formData.append("msb_parent_contract_id", String(body.msb_parent_contract_id));
        formData.append("period_start_date", body.period_start_date);
        formData.append("period_end_date", body.period_end_date);
        formData.append("description", body.description);
        formData.append("amount", String(body.amount));
        if (body.sf_number) formData.append("sf_number", body.sf_number);
        if (body.sf_date) formData.append("sf_date", body.sf_date);
        if (body.file) {
          formData.append("file", body.file);
        }
        return {
          url: "/api/hr/self-service/msb-completion-acts/",
          method: "POST",
          body: formData,
          credentials: "include" as const,
        };
      },
      invalidatesTags: [{ type: "MsbContract" as const, id: "CONTRACT" }],
    }),

    updateMsbCompletionAct: builder.mutation<
      MsbCompletionAct,
      { id: number; body: UpdateMsbCompletionActDto }
    >({
      query: ({ id, body }) => {
        const formData = new FormData();
        if (body.period_start_date !== undefined) formData.append("period_start_date", body.period_start_date);
        if (body.period_end_date !== undefined) formData.append("period_end_date", body.period_end_date);
        if (body.description !== undefined) formData.append("description", body.description);
        if (body.amount !== undefined) formData.append("amount", String(body.amount));
        if (body.sf_number !== undefined) formData.append("sf_number", body.sf_number);
        if (body.sf_date !== undefined) formData.append("sf_date", body.sf_date);
        if (body.file) formData.append("file", body.file);
        return {
          url: `/api/hr/self-service/msb-completion-acts/${id}/`,
          method: "PATCH",
          body: formData,
          credentials: "include" as const,
        };
      },
      invalidatesTags: [{ type: "MsbContract" as const, id: "CONTRACT" }],
    }),

    deleteMsbCompletionAct: builder.mutation<void, number>({
      query: (id) => ({
        url: `/api/hr/self-service/msb-completion-acts/${id}/`,
        method: "DELETE",
        credentials: "include" as const,
      }),
      invalidatesTags: [{ type: "MsbContract" as const, id: "CONTRACT" }],
    }),
  }),
});

export const {
  useGetMsbContractQuery,
  useCreateMsbCompletionActMutation,
  useUpdateMsbCompletionActMutation,
  useDeleteMsbCompletionActMutation,
} = msbContractApi;
